<template>
    <div>
        <div>
            <el-form ref="form" :inline="true" class="query-form" size="mini">

                <el-form-item class="query-form-item">
                    <el-form-item label="状态：" class="query-form-item">
                        <el-select v-model="query.status" placeholder="状态" size="mini" style="width: 120px;">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="建库导入完成" :value="3"></el-option>
                            <el-option label="keepa爬取中" :value="4"></el-option>
                            <el-option label="keepa爬取完成" :value="5"></el-option>
                            <el-option label="爬取1688链接中" :value="6"></el-option>
                            <el-option label="重新获取1688链接中" :value="7"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="ASIN：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="标题：" class="query-form-item">
                        <el-input style="width: 100px;" clearable v-model="query.title" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="销售国家：" class="query-form-item" prop="state">
                        <el-select v-model="query.category_state" style="width: 100px;" size="mini" filterable>
                            <el-option v-for="item in $common.us_arr" :key="item.us" :label="item.title" :value="item.us" :disabled="item.disabled">
                                <div class="keywords_arr_div">
                                    <icon-svg :icon-class="item.us.toUpperCase()"
                                              style="font-size: 24px;margin-right:5px;"></icon-svg>
                                    <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button type="primary" @click="addSubLibrary">批量导入</el-button>

                </el-form-item>
            </el-form>
            <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                      @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                      @selection-change="handleSelectionChange"
                      class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">


                <el-table-column label="ID" width="60" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.id }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="图片" width="120" align="center">
                    <template slot-scope="scope">
                        <div v-if="!scope.row.img_url">暂无图片</div>
                        <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                    </template>
                </el-table-column>
                <table-asin-column></table-asin-column>

                <el-table-column label="创建时间" width="180" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.create_time }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <div>{{ statusObj[scope.row.status] }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="销售国家" width="80" align="center">
                    <template slot-scope="scope">
                        <div>
                            <icon-svg
                                :icon-class="(scope.row.category_state || '').toUpperCase()"
                                style="font-size: 24px;margin-left:5px;"
                            ></icon-svg>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    width="110"
                    align="center"
                    label="父asin">
                    <template slot-scope="scope">
                        <span>{{ scope.row.parent_asin }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="上架时间" width="140" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.listed_since }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="品牌" width="100" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.brand }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="评分" width="70" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.rating }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="评论数" width="70" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.rating_count }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="标题" min-width="250" align="center">
                    <template slot-scope="scope">
                        <div class="fixedHeight">{{ scope.row.title }}</div>
                    </template>
                </el-table-column>


                <el-table-column label="类目" min-width="360" align="center">
                    <template slot-scope="scope">
                        <div class="fixedHeight">{{ scope.row.category }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="长(cm)*宽(cm)*高(cm)-重(g)" width="190" align="center">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.long }}*{{ scope.row.wide }}*{{
                                scope.row.height
                            }}-{{ scope.row.weight }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="1688链接失败信息" width="140" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.ali_err_message }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="deleteFunc(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :page-size="query.limit" :current-page="query.page"
                           :page-sizes="[20, 50, 100]" :total="query.total" background
                           style="float: right;margin-top: 10px;"
                           layout="total, sizes, prev, pager, next">
            </el-pagination>
            <uploadDom :visible="addSubLibraryModal" @close-callback="closeCllback" title="上传"/>

        </div>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'
import {
    batch_self_build_cost_analysis_updating_list, batch_self_build_deleted,
    cost_analysis_assigned_selection_assigned_updating_list
} from '@/api/advAnalys/advAnalys.js'
import uploadDom from './parsingUpload.vue'

let timer = null
export default {
    components: {uploadDom},
    data() {
        return {

            statusObj: {
                3: '导入完成',
                4: 'keepa爬取中',
                5: 'keepa爬取完成',
                6: '爬取1688链接中',
                7: '重试爬取1688链接中',
                // 0: '成本分析待解析',
                // 1: '成本分析解析中',
                // 2: '成本分析完成',
            },
            managerAnalysisList: [],
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            peopleListVisible: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            typeArr: [{
                index: 1,
                title: '广告层面'
            },
                {
                    index: 2,
                    title: '逻辑层面'
                }
            ],
            query: {
                status: '',
                asin: '',
                title: '',
                category_state: '',
                page: 1,
                limit: 20,
                total: 0,
            },
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
            subLibraryDetailInfo: {},
            showPageType: 0,
            addSubLibraryModal: false,
            upadteRankingModal: false,
        }
    },
    computed: {
        showAdd() {
            return this.$checkPermission('admin/branch_warehouse/manager/add')
        },
        showDel() {
            return this.$checkPermission('admin/branch_warehouse/manager/delete')
        },
        show1688() {
            return this.$checkPermission('admin/branch_warehouse/link/update_link')
        },
        showGetPeople() {
            return this.$checkPermission('admin/branch_warehouse/manager/get_developers')
        },
        showDetail() {
            return this.$checkPermission('admin/branch_warehouse/details/get_detail_category')
        },
        showCostAnalysis() {
            return this.$checkPermission('admin/cost_analysis/index/index')
        },
    },
    created() {
        this.getList()
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        }
    },
    destroyed() {
        clearInterval(timer)
    },
    methods: {
        deleteFunc(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.batch_self_build_deleted({id: data.id}).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            })
        },
        openModal(arr) {
            if(arr.length) {
                this.$refs.chooseDevelopModal.visible = true
                this.$refs.chooseDevelopModal.list = arr
            }
        },
        seeDetail(data) {
            this.subLibraryDetailInfo = data
            this.showPageType = 1
        },
        costAnalysis(data) {
            this.subLibraryDetailInfo = data
            this.showPageType = 2
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        seeUrl(row) {
            this.childInfo.title = '1688链接'
            this.childInfo.info = row.href_link
            this.ctrl.childInfoVisible = true
        },
        jumpUrl(row) {
            if (Array.isArray(row.skip_href_link) && row.skip_href_link.length > 0) {
                window.open(row.skip_href_link[0], '_blank')
            } else {
                this.$message.warning('没有链接')
            }
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        addDataFunc() {
            this.editType = 0
            this.showAddRecord = true
        },
        copyDataFunc(data, type) {
            this.showAddRecord = true
            let tempDate = JSON.parse(JSON.stringify(data))
            tempDate.is_peak_season = tempDate.is_peak_season == 1 ? true : false
            tempDate.is_seasonality = tempDate.is_seasonality == 1 ? true : false
            this.editType = type
            this.copyData = tempDate
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.branch_warehouse_manager_delete({id: data.id}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        update_records(data) {
            api.branch_warehouse_line_update_link({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('更新中')
                    this.getList()
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(res => {
                this.$message({type: 'error', message: res.message})
            })
        },
        getUpdateStatus(data) {
            api.branch_warehouse_line_get_update_status({id: data.id}).then((res) => {
                const h = this.$createElement
                this.$notify({
                    title: '提示',
                    message: h('i', {style: 'color: teal'}, res.data || ''),
                    duration: 5000
                })

            }).catch(res => {
                this.$message({type: 'error', message: res.message})
            })
        },
        getPeaple_records(data) {
            this.subLibraryDetailInfo = data
            this.peopleListVisible = true
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.alibaba_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getList() {
            this.loading = true
            api.batch_self_build_cost_analysis_updating_list(this.query).then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.categoryTree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                status: '',
                asin: '',
                title: '',
                category_state: '',
                page: 1,
                limit: 20,
                total: 0,
            }
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 类目列表
        categoryList() {
            this.showCategoryList = true
        },
        addSubLibrary() {
            this.addSubLibraryModal = true
        },
        upadteRanking() {
            this.upadteRankingModal = true
        },
        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.showPageType = 0
            this.addSubLibraryModal = false
            this.upadteRankingModal = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        goBackList() {
            this.showPageType = 0
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
    color: red;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
